import { gql, useQuery } from "@apollo/client";
import React, { useContext } from "react";
import { useRouteMatch } from "react-router-dom";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../../components/light/Breadcrumb";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { ContextUser } from "../../../../context/ContextUser";

const QUERY = gql`
  query massUpload($batchId: Int!, $supplierId: Int!) {
    massUpload(batchId: $batchId, supplierId: $supplierId) {
      batch {
        id
        reference
        progress
        total
        createdAt
        status
      }
      uploadedProducts {
        supplierCode
        productId
        id
        status
      }
      errors
      products {
        id
        picture
        supplierCode
        title {
          en
          km
          zh
        }
        size
        color
        price
        supplierId
        categoryId
      }
    }
  }
`;

export function MassProductDetailScreen() {
  const context = useContext(ContextUser);
  const match: any = useRouteMatch();
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      batchId: Number(match.params.id),
      supplierId: Number(context.merchant.id),
    },
  });

  const BreadCrumbItems: BreadCrumbProp[] = [
    {
      text: "Applications",
      to: "#",
    },
    {
      text: "Products",
      to: "#",
    },
    {
      text: "Mass Upload",
      to: "/product/mass/list",
    },
    {
      text: "Detail",
      to: "/product/mass/detail/" + match.params.id,
    },
  ];

  if (loading || data === undefined) return <div></div>;

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-12">
          <SectionBlock title="Summary Mass Upload Product" transparent={true}>
            <div className="row">
              <div className="col-sm-4 col-xxxl-3">
                <div className="element-box el-tablo">
                  <div className="label">Batch ID</div>
                  <div className="value">{data.massUpload.batch.id}</div>
                </div>
              </div>
              <div className="col-sm-4 col-xxxl-3">
                <div className="element-box el-tablo">
                  <div className="label">Error</div>
                  <div className="value">{data.massUpload.errors.length}</div>
                </div>
              </div>
              <div className="col-sm-4 col-xxxl-3">
                <div className="element-box el-tablo">
                  <div className="label">Total</div>
                  <div className="value">{data.massUpload.batch.total}</div>
                </div>
              </div>
              <div className="col-sm-4 col-xxxl-3">
                <div className="element-box el-tablo">
                  <div className="label">progress</div>
                  <div className="value">{data.massUpload.batch.progress}</div>
                </div>
              </div>
            </div>
          </SectionBlock>
        </div>
        <div className="col-md-12">
          <SectionBlock title="Product" transparent={true}>
            <table className="table table-padded">
              <thead>
                <tr>
                  <th className="text-center">No.</th>
                  <th className="text-center">Picture</th>
                  <th style={{ width: 200 }}>Supplier Code</th>
                  <th>title</th>
                  <th className="text-center">color</th>
                  <th className="text-center">size</th>
                  <th className="text-center">price</th>
                  <th className="text-center">status</th>
                  <th className="text-center">message</th>
                </tr>
              </thead>
              <tbody>
                {data.massUpload.products.map((x: any, i: number) => {
                  const uploadIndex = data.massUpload.uploadedProducts.findIndex((y: any) => y.supplierCode === x.supplierCode);
                  const errorIndex = data.massUpload.errors.findIndex((y: any) => y.product_idx === i);
                  return (
                    <tr key={i}>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>{i+1}</td>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>
                        <img
                          src={x.picture}
                          alt=""
                          width={75}
                          style={{ objectFit: "cover", borderRadius: 4 }}
                        />
                      </td>
                      <td style={{ width: 200 }} className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>
                        <small>{x.supplierCode}</small>
                      </td>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>
                        <small>{x.title ? x.title.en : ""}</small>
                      </td>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>
                        {x.color
                          ? x.color.map((c: any) => (
                              <div>
                                <small>{c}</small>
                              </div>
                            ))
                          : ""}
                      </td>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>
                        {x.size
                          ? x.size.map((s: any) => (
                              <div>
                                <small>{s}</small>
                              </div>
                            ))
                          : ""}
                      </td>
                      <td className={`text-center text-success bolder nowrap ${errorIndex >= 0 ? 'bg-danger' : ""}`}>
                        {x.price} USD
                      </td>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}>{ uploadIndex >= 0 ?  data.massUpload.uploadedProducts[uploadIndex].status : ''}</td>
                      <td className={`text-center ${errorIndex >= 0 ? 'bg-danger text-light' : ""}`}><small>{errorIndex >= 0 ? data.massUpload.errors[errorIndex].message : ''}</small></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </SectionBlock>
        </div>
      </div>
    </Content>
  );
}
